/**
 * Do not edit directly
 * Generated on Mon, 15 Apr 2024 06:34:29 GMT
 */
const tokens = {
    component: {
        calendar: {
            container: {
                padding: {
                    value: "24px",
                    type: "dimension",
                },
                gap: {
                    value: "24px",
                    type: "dimension",
                },
            },
            stepper: {
                button: {
                    color: {
                        value: "#d3222a",
                        type: "color",
                    },
                },
            },
            yearsView: {
                gap: {
                    value: "8px",
                    type: "dimension",
                },
                paddingLeft: {
                    value: "4px",
                    type: "dimension",
                },
                paddingRight: {
                    value: "4px",
                    type: "dimension",
                },
                paddingTop: {
                    value: "4px",
                    type: "dimension",
                },
                paddingBottom: {
                    value: "4px",
                    type: "dimension",
                },
                year: {
                    medium: {
                        width: {
                            value: "64px",
                            type: "dimension",
                        },
                        height: {
                            value: "32px",
                            type: "dimension",
                        },
                        borderRadius: {
                            value: "8px",
                            type: "dimension",
                        },
                        fontSize: {
                            value: "0.875rem",
                            type: "dimension",
                        },
                        lineHeight: {
                            value: "1.25rem",
                            type: "dimension",
                        },
                        fontWeight: {
                            value: 400,
                            type: "number",
                        },
                        letterSpacing: {
                            value: "0.2px",
                            type: "dimension",
                        },
                    },
                },
            },
            monthsView: {
                gap: {
                    value: "8px",
                    type: "dimension",
                },
                paddingLeft: {
                    value: "4px",
                    type: "dimension",
                },
                paddingRight: {
                    value: "4px",
                    type: "dimension",
                },
                paddingTop: {
                    value: "8px",
                    type: "dimension",
                },
                paddingBottom: {
                    value: "8px",
                    type: "dimension",
                },
                month: {
                    medium: {
                        width: {
                            value: "64px",
                            type: "dimension",
                        },
                        height: {
                            value: "32px",
                            type: "dimension",
                        },
                        borderRadius: {
                            value: "8px",
                            type: "dimension",
                        },
                        fontSize: {
                            value: "0.875rem",
                            type: "dimension",
                        },
                        lineHeight: {
                            value: "1.25rem",
                            type: "dimension",
                        },
                        fontWeight: {
                            value: 400,
                            type: "number",
                        },
                        letterSpacing: {
                            value: "0.2px",
                            type: "dimension",
                        },
                    },
                },
            },
            monthView: {
                gap: {
                    value: "8px",
                    type: "dimension",
                },
                weekHeader: {
                    gap: {
                        value: "8px",
                        type: "dimension",
                    },
                    day: {
                        width: {
                            value: "32px",
                            type: "dimension",
                        },
                        height: {
                            value: "32px",
                            type: "dimension",
                        },
                        fontSize: {
                            value: "0.875rem",
                            type: "dimension",
                        },
                        lineHeight: {
                            value: "1.25rem",
                            type: "dimension",
                        },
                        fontWeight: {
                            value: 400,
                            type: "number",
                        },
                        letterSpacing: {
                            value: "0.2px",
                            type: "dimension",
                        },
                        color: {
                            value: "#6f7377",
                            type: "color",
                        },
                    },
                },
                weeks: {
                    gap: {
                        value: "8px",
                        type: "dimension",
                    },
                },
                day: {
                    medium: {
                        width: {
                            value: "32px",
                            type: "dimension",
                        },
                        height: {
                            value: "32px",
                            type: "dimension",
                        },
                        borderRadius: {
                            value: "8px",
                            type: "dimension",
                        },
                        fontSize: {
                            value: "0.875rem",
                            type: "dimension",
                        },
                        lineHeight: {
                            value: "1.25rem",
                            type: "dimension",
                        },
                        fontWeight: {
                            value: 400,
                            type: "number",
                        },
                        letterSpacing: {
                            value: "0.2px",
                            type: "dimension",
                        },
                    },
                    unselected: {
                        default: {
                            backgroundColor: {
                                value: "#ffffff",
                                type: "color",
                            },
                            color: {
                                value: "#282e37",
                                type: "color",
                            },
                        },
                        hover: {
                            backgroundColor: {
                                value: "#f3f3f3",
                                type: "color",
                            },
                            color: {
                                value: "#282e37",
                                type: "color",
                            },
                        },
                        disabled: {
                            backgroundColor: {
                                value: "#ffffff",
                                type: "color",
                            },
                            color: {
                                value: "#a0a2a5",
                                type: "color",
                            },
                        },
                    },
                    selected: {
                        default: {
                            backgroundColor: {
                                value: "#d3222a",
                                type: "color",
                            },
                            color: {
                                value: "#ffffff",
                                type: "color",
                            },
                            fontWeight: {
                                value: 400,
                                type: "number",
                            },
                        },
                        hover: {
                            backgroundColor: {
                                value: "#af292e",
                                type: "color",
                            },
                            color: {
                                value: "#ffffff",
                                type: "color",
                            },
                        },
                        disabled: {
                            backgroundColor: {
                                value: "#ffffff",
                                type: "color",
                            },
                            color: {
                                value: "#a0a2a5",
                                type: "color",
                            },
                        },
                    },
                    current: {
                        default: {
                            borderColor: {
                                value: "#d3222a",
                                type: "color",
                            },
                            borderWidth: {
                                value: "1px",
                                type: "dimension",
                            },
                            borderStyle: {
                                value: "solid",
                                type: "borderStyle",
                            },
                            backgroundColor: {
                                value: "#ffffff",
                                type: "color",
                            },
                            color: {
                                value: "#282e37",
                                type: "color",
                            },
                        },
                        hover: {
                            borderColor: {
                                value: "#d3222a",
                                type: "color",
                            },
                            borderWidth: {
                                value: "1px",
                                type: "dimension",
                            },
                            borderStyle: {
                                value: "solid",
                                type: "borderStyle",
                            },
                            backgroundColor: {
                                value: "#f3f3f3",
                                type: "color",
                            },
                            color: {
                                value: "#282e37",
                                type: "color",
                            },
                        },
                        disabled: {
                            borderColor: {
                                value: "#d3222a",
                                type: "color",
                            },
                            borderWidth: {
                                value: "1px",
                                type: "dimension",
                            },
                            borderStyle: {
                                value: "solid",
                                type: "borderStyle",
                            },
                            backgroundColor: {
                                value: "#ffffff",
                                type: "color",
                            },
                            color: {
                                value: "#a0a2a5",
                                type: "color",
                            },
                        },
                    },
                    range: {
                        backgroundColor: {
                            value: "#e6e6e6",
                            type: "color",
                        },
                        first: {
                            borderTopLeftRadius: {
                                value: "8px",
                                type: "dimension",
                            },
                            borderBottomLeftRadius: {
                                value: "8px",
                                type: "dimension",
                            },
                        },
                        last: {
                            borderTopRightRadius: {
                                value: "8px",
                                type: "dimension",
                            },
                            borderBottomRightRadius: {
                                value: "8px",
                                type: "dimension",
                            },
                        },
                    },
                },
            },
        },
    },
};
export default tokens;
